import * as React from "react";
import { MiddlePanelConstant } from "../../WorkkardDetail/constants";
import UserImage from '../../../components/UserImage/index';

const LogCell = (props) => {  
  const renderLogDetail = (field, value,profile) => {
    switch (field) {
      case "Priority":
        switch (value) {
          case "3":
            return <div className="Priority high">High</div>;
          case "2":
            return <div className="Priority high">Normal</div>;
          case "1":
            return <div className="Priority high">Low</div>;
        }
      case "Status":
        return (
          <div className="flexGrow">
            <span className="status">{value}</span>
          </div>
        );
      case "Owner":
        return (
          <p>
            <a href={profile}> {value} </a>
          </p>
        );
      case 'Description':{
        return <p className="descriptionFormating" dangerouslySetInnerHTML={{ __html: value }}></p>
      }
      default:
        return value;
    }
  };

  const renderLogHead = (data) => {
    switch (data.Field) {
      case "DueDate":
        return data.OldValue ? (
          <>
            Changed <span className="changed_field ml">Due Date</span>
          </>
        ) : (
          <>
            Added <span className="changed_field ml">Due Date</span>
          </>
        );
        case "DueDateTz":
          return data.OldValue ? (
            <>
              Changed <span className="changed_field ml">DueDateTimezone</span>
            </>
          ) : (
            <>
              Added <span className="changed_field ml">DueDateTimezone</span>
            </>
          );
          case "ReminderTz":
            return data.OldValue ? (
              <>
                Changed <span className="changed_field ml">ReminderTimezone</span>
              </>
            ) : (
              <>
                Added <span className="changed_field ml">ReminderTimezone</span>
              </>
            );    
      default:
        return data.OldValue ? (
          <>
            Changed
            <span className="changed_field ml">{data.Field}</span>
          </>
        ) : (
          <>
            Added
            <span className="changed_field ml">{data.Field}</span>
          </>
        );
    }
  };

  const checkUpdatedValue=(field,newValue,newOwnerProfileUrl)=>{
    if(newValue==""){
      newValue="-";
    }
   return renderLogDetail(field,newValue,newOwnerProfileUrl);
  }

  return (
    <div className="logListing detailListing" key={props.id}>
      <div data-test="ProfileFullImage" className="logCreatedDate detailCreatedDate">
      <UserImage profileUrl={props.data.OwnerView.ProfileFullImage} className="profilePic" profileName={props.data.OwnerView.DisplayName}/>
                
      </div>
      <div data-test="DisplayName" className="logRightBlock detailRightBlock">
        <div className="logDescription detailDescription">
          <div className="mb__8">
            <span className="userInfo alignMiddle">
              {props.data.OwnerView.DisplayName}
              <span className="dateTime">
                <label className="mrNone">{props.data.NonFormatedUpdatedDate.split("at")[1]}</label>
              </span>
            </span>
          </div>
          {props.data.TodoUpdates &&
            props.data.TodoUpdates.map((updates, key) => {
              return (
                <React.Fragment>
                  <span>
                    {renderLogHead(updates)}
                  </span>
                  <div className="col-2 rowFlex formTags mb__8">
                    {
                      updates.OldValue && 
                      <div className="colFlex mr__1" key={key}>
                        <label>From</label>
                        <div className="label">
                        {
                          updates.Field == 'Tag' ?
                          (
                            updates.OldValue.split("|$tag@sep$|").map(element => {
                              return <label className="mr status tags">{element}</label>
                            })
                          )
                          :
                          renderLogDetail(updates.Field, updates.OldValue, updates.OldOwnerProfileUrl)
                        }
                        </div>
                      </div>
                    }
                    <div className="colFlex mr__1" key={key}>
                      {updates.OldValue && <label>{MiddlePanelConstant.To}</label>}
                      <div>
                      {
                        updates.Field == 'Tag' ?
                        (
                          updates.NewValue.split("|$tag@sep$|").map(element => {
                            return <span className="tag-wrapper ReactTags__tag">{element}</span>
                          })
                        )
                        :
                        checkUpdatedValue(updates.Field,updates.NewValue,updates.NewOwnerProfileUrl)
                      }
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          {props.data.Field == "CreationLog" && <span>Created this diary</span>}
        </div>
      </div>
    </div>
  );
};

export default LogCell;
